<template>
    <div class="cu-panel">
        <div class="cu-panel-header">
            {{trans_heading}}
        </div>
        <div class="cu-panel-body">
            <div class="tw-flex tw-items-center tw-gap-4">
                <input id="date_from" name="date_from" type="date" class="form-control" v-model="from">
                <input id="date_to" name="date_to" type="date" class="form-control" v-model="to">
                <button class="cu-btn-default" @click="fetchData">OK</button>
            </div>

            <table class="cu-table tw-mt-4">
                <thead>
                <tr>
                    <th></th>
<!--                    <th class="text-right">Stunden Kostenrechnung</th>-->
<!--                    <th class="text-right">Tage  Kostenrechnung</th>-->
                    <th class="text-right">Stunden Zeiterfassung</th>
<!--                    <th class="text-right">Tage Zeiterfassung</th>-->
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>+ Gearbeitet</td>
<!--                    <td class="text-right">{{data.worked.toLocaleString()}} | {{data.workedFormat}}</td>-->
<!--                    <td class="text-right">{{workedInDays.toLocaleString()}}</td>-->
                    <td class="text-right">{{data.tracked.toLocaleString()}} | {{data.trackedFormat}}</td>
<!--                    <td class="text-right">{{trackedInDays.toLocaleString()}}</td>-->
                </tr>
                <tr>
                    <td>+ Abwesend</td>
<!--                    <td class="text-right">{{data.absent.toLocaleString()}} | {{data.absentFormat}}</td>-->
<!--                    <td class="text-right">{{data.absentDays.toLocaleString()}}</td>-->
                    <td class="text-right">{{data.absent.toLocaleString()}} | {{data.absentFormat}}</td>
<!--                    <td class="text-right">{{data.absentDays.toLocaleString()}}</td>-->
                </tr>
                <tr>
                    <td>+ Feiertage</td>
<!--                    <td class="text-right">{{data.publicHoliday.toLocaleString()}} | {{data.holidayFormat}}</td>-->
<!--                    <td class="text-right">{{publicHolidayInDays.toLocaleString()}}</td>-->
                    <td class="text-right">{{data.publicHoliday.toLocaleString()}} | {{data.holidayFormat}}</td>
<!--                    <td class="text-right">{{publicHolidayInDays.toLocaleString()}}</td>-->
                </tr>
                <tr>
                    <td>+ Angepasste Stunden</td>
<!--                    <td class="text-right">{{data.manualOvertime.toLocaleString()}} | {{data.manualOvertimeFormat}}</td>-->
<!--                    <td class="text-right">{{data.manualOvertimeDays.toLocaleString()}}</td>-->
                    <td class="text-right">{{data.manualOvertime.toLocaleString()}} | {{data.manualOvertimeFormat}}</td>
<!--                    <td class="text-right">{{data.manualOvertimeDays.toLocaleString()}}</td>-->
                </tr>
                <tr>
                    <td>- Möglich</td>
<!--                    <td class="text-right">{{data.possible.toLocaleString()}} | {{data.possibleFormat}}</td>-->
<!--                    <td class="text-right">{{possibleInDays.toLocaleString()}}</td>-->
                    <td class="text-right">{{data.possible.toLocaleString()}} | {{data.possibleFormat}}</td>
<!--                    <td class="text-right">{{possibleInDays.toLocaleString()}}</td>-->
                </tr>
                <tr>
                    <th>= Differenz</th>
<!--                    <td class="text-right">{{data.overtime.toLocaleString()}} | {{data.overtimeFormat}}</td>-->
<!--                    <td class="text-right">{{overtimeInDays.toLocaleString()}}</td>-->
                    <th class="text-right">{{data.trackedOvertime.toLocaleString()}} | {{data.trackedOTFormat}}</th>
<!--                    <th class="text-right">{{trackedOvertimeInDays.toLocaleString()}}</th>-->
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        components: {},
        data() {
            return {
                trans_heading: Worklog.workTimeTable.trans_heading,
                data: Worklog.workTimeTable.data,
                url: Worklog.workTimeTable.url,
                from: Worklog.workTimeTable.from,
                to: Worklog.workTimeTable.to,
            }
        },
        computed: {
            workedInDays() {
                return Math.round(this.data.worked / 8 * 100) / 100
            },
            trackedInDays() {
                return Math.round(this.data.tracked / 8 * 100) / 100
            },
            absentInDays() {
                return Math.round(this.data.absent / 8 * 100) / 100
            },
            publicHolidayInDays() {
                return Math.round(this.data.publicHoliday / 8 * 100) / 100
            },
            possibleInDays() {
                return Math.round(this.data.possible / 8 * 100) / 100
            },
            overtimeInDays() {
                return Math.round(this.data.overtime / 8 * 100) / 100
            },
            trackedOvertimeInDays() {
                return Math.round(this.data.trackedOvertime / 8 * 100) / 100
            },
        },
        mounted() {
        },
        methods: {
            fetchData() {
                axios.get(this.url.replace(':from', this.from).replace(':to', this.to))
                    .then(response => {
                        this.data = response.data
                    })
                    .catch(e => {

                    })
            }
        }
    }
</script>
